<template>
    <div class="con_content"  style="height:660px;overflow:auto">
        <div class="" style="width:100%" >
            
            <div >
                
                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10">所属类目 : &nbsp;</div> 
                                <div class="lft pointer" :class="[title_num == -1 ?'colorP':'']"  @click="title_num = -1;guid = 'better'"  > 推荐 </div>
                                <div class="lft pointer" v-for="(item,num) in titles" :class="[title_num == num?'colorP':'']"  @click="title_num = num;guid = item.guid" :key="num"> &nbsp; <span class="cBlack">/</span> &nbsp;{{item.name}} </div>
                                
                                                
                            </div> 
                             
                            <!-- <Button class="rgt mR20 top14" @click="route='/layout/circle/music/add';out_btnFun(null,0)"  type="info">添加音乐</Button> 
                            <Button class="rgt mR20 top14" @click="lookFun"  type="info">查看类目</Button>    -->
                        </Row>        
                    </div>
                  
                </div>
                <div class="my_table">
                    
                    <div class="my_search" >
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10 fw900 fon fs18">音乐列表 </div> 
                                       
                            </div> 
                            <Col span="4" class="listIpt rgt mR20">
                                <Input  ref='isFocuseA'    :maxlength='20' @keyup.enter.native="nameFun" v-model="name"  class='ipt   top13 '  placeholder="请输入音乐名"  >
                                    <Button size="small" @click='nameFun'   slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                        </Row>        
                    </div>
                  
                    <Table     border :columns="columns1" :data="data1" ref='table' >
                 
                        <!-- 播放试听 -->
                        <template slot-scope="{ row, index }" slot="url" >
                 
                            <span  >
                                
                                <!-- <audio :src="row.url"  controls> </audio> -->
                                <!--vue-aplayer插件-->
                                 <aplayer   
                                    
                                    :music="{
                                        title: row.name,
                                        author: '家谱纪转载',
                                        url: row.url,
                                        pic: row.thumb,
                                        
                                        preload: 'metadata'
                                    }"
                                    ref="ref_music"
                                  ></aplayer>
                            </span>
  
                        </template>                      
                        <template slot-scope="{ row, index }" slot="btn" >
                 
                            <span  >
                                <Button v-if=" my_url != row.path" size="small"  @click='my_url = row.path;musicFun()'  type="info"   >选择音乐</Button>
                                <Button v-if=" my_url == row.path" size="small"  @click='my_url = "";musicFun();'  type="error"  >选中音乐</Button>
                               
                            </span>

                        </template>                      
                          
                    </Table>
                    <Footer class="bottom0">
                       <Page class="txt_c"  :current.sync="page" :total="total" :page-size='size' :page-size-opts='[5,10,20,40]'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>
                    
                </div>
            </div>
        </div>

        
        
    </div>
    
</template>
<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    
    
    import aplayer from 'vue-aplayer';
    export default {
        name:'music_child',
        data () {
            return {
                my_url: null,

                token: null,
                route: null,
                guid: 'better', 
                my_guid:null,
                titles: [],
                title_num: -1,
                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 5,
                //搜索
                search_page:1,
                search_size: 20,
                // 类目 
                columns:[],   
                data:[],
              
                // 主体编辑
                out_url: null,  //场景路径
                
                out_model1:null,  //场景名称
                out_model2:null,  //场景guid
                out_model3:0,  //场景排序
                out_model4:0,  //是否推荐
                out_model5:0,  //是否隐藏
                out_model6:0,     //收取孝心值
                

                // 类目编辑
                m_model1:null,  //分类名称
                m_model2:null,  //分类描述
                m_model3:null,  //分类排序
                m_model4:null,  //隐藏分类

                name: null,

                lo: false,
                out_btn: null,  
                out_guid: null,
                out_btn_num: null,
                out_title: null,
                out_succ: null,

                lm: false,     //是否弹出类目
                m_btn: false , //类目弹窗的按钮弹窗
                m_guid: null,
                m_btn_num: 0,
                m_title: "添加类目",
                m_succ: "添加",

                // 上传音乐
                up_data: null,
                file_name: null,
                file_path: null,

                

               
            }
        },
        props: ['mbm_url','child_bool'], 
        watch:{
           title_num(val){
               let that = this;
               that.load1();
           },
           child_bool(val,old){
               if(val != old){
                   
                   this.my_url = this.mbm_url;
                   this.load1();
               }
           },
           mbm_url(val){
               let that = this;
               that.my_url = val;
           }
          
        },
        components: {
          aplayer
        },
        computed: {
           
        },
        
        methods: {
            musicFun(){
                let that = this;
                that.$emit('music_val',that.my_url);
                that.$emit('music_open',false);
                this.$Message.info({
                    content:'选择音乐成功',
                    duration:3 
                });
                let aplayer = that.$refs.ref_music;
                aplayer.pause();
            },
            load(){
              let that = this;
              that.$myAjax.get('admin/service/admin/fame/background/type/image?type=1').then( res => {
                  that.titles = res.data.data;
                  
                  that.columns = [
                       {title:'排序',key:'sort',align:'center',width: 80},
                       {title:'名称',key:'name',align:'center',minWidth: 100,ellipsis: true},
                       {title:'分类描述',key:'content',align:'center',minWidth:150}, 
                       {title:'添加时间',key:'createTime',align:'center',minWidth:110,maxWidth:190},
                       {title:'操作',slot:'btn',align:'center',width:160,fixed: 'right'}
                  ];
                  that.data = res.data.data;
                  
                  that.out_model2 = that.data[0].guid;
                  
              })
          },
          load1(){
            
              let that = this;
              let data = {
                  guid: that.guid,
                  page: that.page,
                  size: that.size,
                  type: "1"

              };
              
              
              that.$myAjax.get('admin/service/admin/fame/background/all'+that.$ajaxNull.get(data)).then( res => {
                  that.columns1 = [
                        {title:'排序',key:'sort',align:'center',width: 80},
                        {title:'名称',key:'name',align:'center',minWidth: 100,maxWidth: 250},
                        {title:'播放试听',slot:'url',align:'center',minWidth: 300},
                        {title:'所属条目',key:'backgroundTypeName',align:'center',minWidth: 90,maxWidth:120},
                        {title:'孝心值',key:'money',align:'center',width: 90},
                        {title:'创建时间',key:'createTime',align:'center',minWidth: 110,maxWidth:220},
                        {title:"操作",slot:"btn",align:"center",width:130,fixed: 'right'},
                  ]; 
                  
                  that.data1 = res.data.data.list;
                  that.page = res.data.data.pageNum;
                  that.size = res.data.data.pageSize;
                  that.total = res.data.data.total;
                //   console.log(that.total)
              })
          },
          
          change_page(){
              this.load1();
          },
          change_size(size){
              this.size = size;
              this.load1();
          },
          


            
            // 搜索名称
            nameFun(){
                let that = this;
                let data = {
                  name: that.name,
                  page: that.search_page,
                  size: that.search_size,
                  type: "1"

                };
                if(that.name){
                    that.$myAjax.get('admin/service/admin/fame/background/search'+that.$ajaxNull.get(data)).then( res => {
                        that.data1 = res.data.data.list;
                        that.page = res.data.data.pageNum;
                        that.size = res.data.data.pageSize;
                        that.total = res.data.data.total;
                    })
                }else{
                    that.load1();
                }
                
                
            },
            
           change_out_isBetter(bool){
               this.out_model4 = bool;
               
            },
           change_out_display(bool){
               this.out_model5 = bool;
               
            },
            //   类目
            change_btn(bool){
               this.m_model4 = bool;
               
            },
            //   查看类目
           lookFun(){
               this.lm = true;
           },
            lookSucc(){
               this.lm = false;
            },
            
            
            
           

          
            
         
        },
        mounted: function(){
           let that = this;
           
           that.my_guid = that.$store.state.guid;
           
           that.token = that.$store.state.token;
           that.load();
           that.load1();

        }
    }
</script>
<style scoped>
    
</style>